  document.addEventListener('DOMContentLoaded', function () {
    $('.reviews-section').each(function () {
      var section = $(this);
      var slider = section.find('.reviews-section__slider');
      var dots = section.find('.reviews-section__dots');

      if (!slider.length || slider.hasClass('slick-initialized')) {
        return;
      }

      slider.slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        appendDots: dots,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 500,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 749,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    });
  });